import { useEffect, useRef } from "react";
import { useAuth } from "@/lib/AuthContext";
import { api } from "@/lib/api";

export function useSuggestions(definitions, pageData) {
  const { user, refresh } = useAuth();
  const dismissed = (user && user.suggestions_dismissed) || {};
  const clearingRef = useRef(new Set());

  useEffect(() => {
    definitions.forEach((def) => {
      const conditionTrue = def.condition(pageData);
      if (!conditionTrue && dismissed[def.key] && !clearingRef.current.has(def.key)) {
        clearingRef.current.add(def.key);
        api.delete(`/auth/me/suggestions/${def.key}`)
          .then(() => refresh())
          .catch(() => {})
          .finally(() => clearingRef.current.delete(def.key));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageData, dismissed]);

  const visible = definitions.filter(
    (def) => def.condition(pageData) && !dismissed[def.key],
  );

  const dismiss = (key) =>
    api.patch(`/auth/me/suggestions/${key}`).then(() => refresh()).catch(() => {});

  return { visible, dismiss };
}
